import { AdaBindMethodPipe } from '@adaptiva/core/common';
import { DynamicComponentLoaderModule } from '@adaptiva/core/loaders';
import { AlertComponentModule } from '@adaptiva/widgets/alert';
import { ButtonComponentModule } from '@adaptiva/widgets/button';
import { CardComponentModule } from '@adaptiva/widgets/card';
import { CheckboxComponentModule } from '@adaptiva/widgets/checkbox';
import { ContainerComponentModule } from '@adaptiva/widgets/container';
import { SignpostComponentModule } from '@adaptiva/widgets/signpost';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { OneSiteIntuneCloudContentSettingsEditorComponent } from './onesite-intune-cloud-content-settings-editor.component';

@NgModule({
	imports: [
		AdaBindMethodPipe,
		CommonModule,
		FormsModule,
		AlertComponentModule,
		CardComponentModule,
		CheckboxComponentModule,
		ContainerComponentModule,
		ButtonComponentModule,
		SignpostComponentModule,
		DynamicComponentLoaderModule.forChild(OneSiteIntuneCloudContentSettingsEditorComponent)
	],
	exports: [
		OneSiteIntuneCloudContentSettingsEditorComponent
	],
	declarations: [
		OneSiteIntuneCloudContentSettingsEditorComponent
	]
})
export class OneSiteIntuneCloudContentSettingsEditorModule { }
